import { useState } from 'react';
import { useBadgesPdf } from '#root/queries/badges';

interface UseBadgePrintingResult {
    printBadges: (responderIds: string[]) => Promise<void>;
    isPrinting: boolean;
    printingIds: string[];
}

export const useBadgePrinting = (): UseBadgePrintingResult => {
    const [printingIds, setPrintingIds] = useState<string[]>([]);
    const printBadgesMutation = useBadgesPdf();

    const downloadPdf = (pdfBlob: Blob, singleId?: string) => {
        const pdfUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = singleId ? `${singleId}.pdf` : 'badges.pdf';
        link.click();
        URL.revokeObjectURL(pdfUrl);
    };

    const printBadges = async (responderIds: string[]) => {
        if (!responderIds.length) return;
        
        setPrintingIds(prev => [...prev, ...responderIds]);
        
        try {
            const pdfBlob = await printBadgesMutation.mutateAsync(responderIds);
            if (pdfBlob) {
                downloadPdf(pdfBlob, responderIds.length === 1 ? responderIds[0] : undefined);
            }
        } catch (err) {
            console.error('Badge generation failed:', err);
            throw err;
        } finally {
            setPrintingIds(prev => prev.filter(id => !responderIds.includes(id)));
        }
    };

    return {
        printBadges,
        isPrinting: printBadgesMutation.isPending,
        printingIds
    };
};
